import type React from 'react';
import { memo } from 'react';

import cn from 'classnames';
import format from 'date-fns/format';

import { isEmptySessionNow } from '@shared/helpers';

import * as st from './styles.module.scss';

interface Props {
	start: Date;
	end: Date;
}

export const EmptyStartTime: React.FC<Props> = memo(({ start, end }) => {
	const halfHour = () => format(start, 'mm') === '30';

	const isNow = isEmptySessionNow({ start, end });

	return (
		<div
			className={cn(st.time, st['single'], st.empty, halfHour() && st.halfHour, isNow && st.now)}
			onMouseOver={(e) => e.stopPropagation()}
		>
			{format(start, 'HH:mm')}
		</div>
	);
});
